import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import BatchQuestionsUploader from './BatchQuestionsUploader';
import { database } from '../firebase';
import { ref, onValue, set, get, update, remove, serverTimestamp } from 'firebase/database';
import { NavalConstants } from '../constants/NavalConstants';
import '../styles/global.css';
import { db } from '../firebase';
import { collection, addDoc, getDocs, deleteDoc, doc, serverTimestamp as firestoreTimestamp, query, orderBy, collectionGroup, where } from 'firebase/firestore';
// Mapeo manual entre índices de RTDB y códigos de Firestore (Portado de Vault.jsx)
const RTDB_TO_FIRESTORE_HIERARCHY = {
    '0': 'MRO', '1': 'CBO', '2': '3RM', '3': '2DM', '4': '1RM', '5': 'TTE.CORB.', '6': 'TTE.FRAG.', '7': 'TTE.NAV.', '8': 'CAP.CORB.'
};

const RTDB_TO_FIRESTORE_CORPS = {
    '0': 'CG', '1': 'IM', '2': 'AN', '3': 'MN'
};

const RTDB_TO_FIRESTORE_SERVICES = {
    '0': 'SAIN', '1': 'SAN', '2': 'ING', '3': 'JUS', '4': 'DOC', '5': 'TS', '6': 'MUS', '7': 'SG'
};

const SPECIALTY_NAME_TO_CODE = {
    'Oficinista': 'OFTA', 'Oficinistas': 'OFTA', 'Infanteria de Marina': 'IM', 'Lavandería': 'LAVD', 'Cocina': 'COCN',
    'Armamento': 'ARMM', 'Navegación': 'NAVG', 'Condestable': 'COND', 'Mecánico': 'MEC', 'Electricista': 'ELEC',
    'Electrónica': 'ELTC', 'Torpedos': 'TORP', 'Comunicaciones': 'COM', 'Radar': 'RAD', 'Sonar': 'SON',
    'Contramedidas': 'CMED', 'Piloto Aviador Naval': 'PAN', 'Observador Aéreo': 'OAN', 'Técnico Aeronáutico': 'TAN',
    'Fusilero': 'FUS', 'Artillero': 'ART', 'Médico': 'MED', 'Enfermero': 'ENF', 'Odontólogo': 'ODO', 'Farmacéutico': 'FAR',
    'Médicos Cirujanos': 'MED_CIR', 'Cirujanos Dentistas': 'CIR_DENT', 'Enfermería': 'ENF', 'Psicología': 'PSIC',
    'Nutrición': 'NUTR', 'Sanidad': 'SAN', 'Servicios Generales de Sanidad': 'SGS', 'Químico': 'QUIM',
    'Dentista': 'DENT', 'Radiologo': 'RADIO', 'Laboratorista': 'LAB', 'Licenciada en Pedagogia': 'PEDAG',
    'Licenciada en Educacion Preescolar': 'EDUC_PRE', 'Licenciada en Educacion Primaria': 'EDUC_PRIM',
    'Alimentación': 'ALIM', 'Servicios Generales': 'SG', 'Servicio de Trabajo Social Naval': 'TSN',
    'Costurero': 'COSTR', 'Sastre': 'SSTR', 'Chofer': 'CHOFR', 'Lavandero': 'LAVDR', 'Jardinero': 'JRDNR',
    'Servicios Generales de alimentacion': 'SGA', 'impresor': 'IMPR', 'Camarero': 'CMRR', 'Cocinero': 'COCN',
    'Panadero': 'PNDR', 'Peluquero': 'PLQR', 'Armamento Aereo': 'ARMM_AER', 'Mecánico de Aviación': 'MEC_AVI',
    'Electrónico de Aviación': 'ELE_AVI', 'Operaciones Aereas': 'OPE_AER', 'Controlador de Vuelo': 'CTRL_VLO',
    'Contramaestres': 'CONTRAM', 'Condestables': 'CONDEST', 'Maquinas': 'MAQ', 'Trabajos Submarinos': 'TRAB_SUB',
    'Proteccion Portuaria': 'PROT_PORT', 'Informatico': 'INF', 'Radio Operador': 'RAD_OP', 'Mecánico Automotriz': 'MEC_AUTO',
    'Hidrografía': 'HIDRO', 'Informática/Computación': 'INF_COMP', 'carpintero ': 'CRPNT', 'Tornero': 'TRNR',
    'Soldador': 'SLDR', 'Electromecanico': 'E_MEC', 'Fontanero': 'FONT', 'Criminalistica': 'CRIM',
    'Licenciado en Derecho': 'DER', 'Mecánicos/Motoristas': 'MEC_MOT', 'Electricistas': 'ELEC',
    'Frigoríficos': 'FRIG', 'Control de Averías': 'CTRL_AV', 'Electrónicos': 'ELECTRON',
    'camillero ': 'CAMILL'
};

const AdminQuizzManagement = () => {
    const navigate = useNavigate();
    // Data states
    const [areas, setAreas] = useState([]);
    const [temas, setTemas] = useState([]);
    const [specialtyTemas, setSpecialtyTemas] = useState({});
    const [proposals, setProposals] = useState([]);
    const [navalMetadata, setNavalMetadata] = useState(null);
    const [loading, setLoading] = useState(true);
    const [migrating, setMigrating] = useState(false);

    const [migrationStatus, setMigrationStatus] = useState('');

    // Metadata options and mappings (Dynamic from RTDB)
    const [hierarchyOptions, setHierarchyOptions] = useState([]);
    const [corpsOptions, setCorpsOptions] = useState([]);
    const [specialtyOptions, setSpecialtyOptions] = useState([]);
    const [specialtiesByCorps, setSpecialtiesByCorps] = useState({});
    const [allSpecialties, setAllSpecialties] = useState([]);

    // UI Expansion states
    const [expandedSections, setExpandedSections] = useState({
        migration: false,
        createArea: false,
        createBasicTema: false,
        cloneTema: false,
        copySpecialtyTema: false,
        specialtyQuizz: false,
        bulkAssign: false,
        proposals: true
    });

    // Form states - Copy Specialty Tema
    const [copySrcJerarquia, setCopySrcJerarquia] = useState('');
    const [copySrcCuerpo, setCopySrcCuerpo] = useState('');
    const [copySrcEspecialidad, setCopySrcEspecialidad] = useState('');
    const [copySrcTemaId, setCopySrcTemaId] = useState('');
    const [copyDstJerarquia, setCopyDstJerarquia] = useState('');
    const [copyDstCuerpo, setCopyDstCuerpo] = useState('');
    const [copyDstEspecialidad, setCopyDstEspecialidad] = useState('');
    const [copyDstTemaId, setCopyDstTemaId] = useState('');
    const [copyStatus, setCopyStatus] = useState('');

    // Form states - Basic Area/Tema
    const [newAreaId, setNewAreaId] = useState('');
    const [newAreaNombre, setNewAreaNombre] = useState('');
    const [newTemaId, setNewTemaId] = useState('');
    const [newTemaNombre, setNewTemaNombre] = useState('');
    const [selectedAreaId, setSelectedAreaId] = useState('');

    // Form states - Cloning
    const [originalTemaId, setOriginalTemaId] = useState('');
    const [targetCloneId, setTargetCloneId] = useState('');

    // Form states - Bulk Assign
    const [bulkRanks, setBulkRanks] = useState([]);
    const [bulkCuerpo, setBulkCuerpo] = useState('TODOS');
    const [bulkEspecialidad, setBulkEspecialidad] = useState('TODOS');
    const [bulkSearchQuery, setBulkSearchQuery] = useState('');
    const [selectedBulkThemeIds, setSelectedBulkThemeIds] = useState([]);
    const [isStrictMode, setIsStrictMode] = useState(false);

    // Form states - Quizz
    const [specialtyQuizzJerarquia, setSpecialtyQuizzJerarquia] = useState('');
    const [specialtyQuizzCuerpo, setSpecialtyQuizzCuerpo] = useState('');
    const [specialtyQuizzEspecialidad, setSpecialtyQuizzEspecialidad] = useState('');
    const [specialtyQuizzTemaId, setSpecialtyQuizzTemaId] = useState('');
    const [quizzId, setQuizzId] = useState('');
    const [quizzTitulo, setQuizzTitulo] = useState('');
    const [quizzJson, setQuizzJson] = useState('');
    const [lastGeneratedQuiz, setLastGeneratedQuiz] = useState(null);

    // Form states - General Quizz
    const [generalQuizzAreaId, setGeneralQuizzAreaId] = useState('');
    const [generalQuizzTemaId, setGeneralQuizzTemaId] = useState('');

    // Metadata helpers (Fallback to constants if metadata not loaded)
    const GRADOS_LIST = hierarchyOptions.length > 0 ? hierarchyOptions.map(h => h.name) : NavalConstants.GRADOS;
    const CUERPOS_LIST = corpsOptions.length > 0 ? corpsOptions.map(c => c.name) : NavalConstants.CUERPOS_Y_SERVICIOS;

    const getSpecialtiesForCuerpo = (cuerpoName) => {
        if (specialtiesByCorps[cuerpoName]) return specialtiesByCorps[cuerpoName];
        return NavalConstants.ESPECIALIDADES[cuerpoName] || [];
    };

    const processMetadata = (data) => {
        // 1. Cuerpos y Servicios
        const corpsList = [];
        if (data.cuerpos_y_servicios) {
            Object.entries(data.cuerpos_y_servicios).forEach(([index, name]) => {
                const idx = parseInt(index);
                let firestoreCode, type;
                if (idx >= 0 && idx <= 3) {
                    firestoreCode = RTDB_TO_FIRESTORE_CORPS[index] || `CG${index}`;
                    type = 'cuerpo';
                } else {
                    const serviceIdx = (idx - 4).toString();
                    firestoreCode = RTDB_TO_FIRESTORE_SERVICES[serviceIdx] || `SRV${index}`;
                    type = 'servicio';
                }
                corpsList.push({ code: firestoreCode, name, type, rtdbIndex: index });
            });
        }
        setCorpsOptions(corpsList);

        // 2. Grados
        if (data.grados) {
            const hierarchies = Object.entries(data.grados).map(([index, value]) => {
                const firestoreCode = RTDB_TO_FIRESTORE_HIERARCHY[index] || `GRD${index}`;
                return { code: firestoreCode, name: value, rtdbIndex: index };
            });
            setHierarchyOptions(hierarchies);
        }

        // 3. Especialidades
        const specialtiesMap = {};
        const allSpecsSet = new Set();
        if (data.especialidades) {
            Object.entries(data.especialidades).forEach(([name, specs]) => {
                if (Array.isArray(specs)) {
                    specialtiesMap[name] = specs;
                    specs.forEach(spec => allSpecsSet.add(spec));
                }
            });
        }
        setSpecialtiesByCorps(specialtiesMap);

        const allSpecs = Array.from(allSpecsSet).map(specName => {
            const firestoreCode = SPECIALTY_NAME_TO_CODE[specName] || specName;
            return { code: firestoreCode, name: specName };
        });
        setAllSpecialties(allSpecs);
        setSpecialtyOptions(allSpecs);
    };

    useEffect(() => {
        const refs = {
            areas: ref(database, 'areas'),
            temas: ref(database, 'temas'),
            proposals: ref(database, 'specialty_proposals'),
            metadata: ref(database, 'app_metadata')
        };

        const unsubs = [
            onValue(refs.areas, snap => setAreas(snap.exists() ? Object.values(snap.val()) : [])),
            onValue(refs.temas, snap => setTemas(snap.exists() ? Object.values(snap.val()) : [])),
            onValue(refs.proposals, snap => {
                if (snap.exists()) {
                    const data = snap.val();
                    const list = Object.entries(data)
                        .map(([id, val]) => ({ id, ...val }))
                        .filter(p => p.status !== 'approved' && p.status !== 'rejected');
                    setProposals(list);
                } else {
                    setProposals([]);
                }
            }),
            onValue(refs.metadata, snap => {
                if (snap.exists()) {
                    const data = snap.val();
                    setNavalMetadata(data);
                    processMetadata(data);
                }
            })
        ];

        setLoading(false);
        return () => unsubs.forEach(unsub => unsub());
    }, []);

    // Carga SOLO los temas de la combinación origen de "Copiar Tema de Especialidad"
    // bajo demanda. Antes se descargaba el árbol completo `especialidades_temas` (~42 MB).
    const [specialtyTemasLoading, setSpecialtyTemasLoading] = useState(false);
    useEffect(() => {
        if (!copySrcJerarquia || !copySrcCuerpo || !copySrcEspecialidad) {
            setSpecialtyTemas({});
            return undefined;
        }
        let cancelled = false;
        setSpecialtyTemasLoading(true);
        get(ref(database, `especialidades_temas/${copySrcJerarquia}/${copySrcCuerpo}/${copySrcEspecialidad}/temas`))
            .then((snap) => {
                if (cancelled) return;
                const temas = snap.exists() ? snap.val() : {};
                setSpecialtyTemas({ [copySrcJerarquia]: { [copySrcCuerpo]: { [copySrcEspecialidad]: { temas } } } });
            })
            .catch(() => { if (!cancelled) setSpecialtyTemas({}); })
            .finally(() => { if (!cancelled) setSpecialtyTemasLoading(false); });
        return () => { cancelled = true; };
    }, [copySrcJerarquia, copySrcCuerpo, copySrcEspecialidad]);

    const toggleSection = (section) => {
        setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
    };

    // --- ACTIONS ---

    const handleBulkMigration = async () => {
        if (!window.confirm("¿Iniciar migración espejo? Se agruparán /preguntas en /preguntas_por_tema")) return;

        try {
            setMigrating(true);
            setMigrationStatus('Leyendo preguntas legacy...');

            const oldSnap = await get(ref(database, 'preguntas'));
            if (!oldSnap.exists()) {
                setMigrationStatus('No hay preguntas para migrar.');
                setMigrating(false);
                return;
            }

            const questions = oldSnap.val();
            const questionsByTheme = {};
            let count = 0;

            Object.entries(questions).forEach(([qid, qData]) => {
                const tId = qData.tema_id || qData.temaId || 0;
                if (!questionsByTheme[tId]) questionsByTheme[tId] = {};
                questionsByTheme[tId][qid] = qData;
                count++;
            });

            setMigrationStatus(`Agrupadas ${count} preguntas en ${Object.keys(questionsByTheme).length} temas. Subiendo...`);

            const updates = {};
            Object.entries(questionsByTheme).forEach(([tId, qs]) => {
                if (tId !== "0") {
                    updates[`preguntas_por_tema/${tId}`] = qs;
                }
            });

            await update(ref(database), updates);
            setMigrationStatus(`✅ Migración completada: ${count} preguntas procesadas.`);
            alert("Migración finalizada exitosamente");
        } catch (e) {
            setMigrationStatus(`❌ Error: ${e.message}`);
        } finally {
            setMigrating(false);
        }
    };

    const handleCreateBasicTema = async () => {
        if (!selectedAreaId || !newTemaId || !newTemaNombre) return alert('Campos faltantes');
        try {
            await update(ref(database, `temas/${newTemaId}`), {
                id: parseInt(newTemaId),
                nombre: newTemaNombre,
                area_id: parseInt(selectedAreaId),
                grados: 'TODOS',
                cuerpo_servicio: 'TODOS',
                especialidad: 'TODOS'
            });
            alert('Tema general creado. No olvides asignarle grados.');
            setNewTemaId(''); setNewTemaNombre('');
        } catch (e) { alert(e.message); }
    };

    const handleCloneTema = async () => {
        if (!originalTemaId || !targetCloneId) return;
        try {
            const sourceSnap = await get(ref(database, `temas/${originalTemaId}`));
            if (!sourceSnap.exists()) return alert('Tema origen no encontrado');

            const sourceData = sourceSnap.val();
            await set(ref(database, `temas/${targetCloneId}`), {
                ...sourceData,
                id: parseInt(targetCloneId)
            });

            const questionsSnap = await get(ref(database, `preguntas_por_tema/${originalTemaId}`));
            if (questionsSnap.exists()) {
                await set(ref(database, `preguntas_por_tema/${targetCloneId}`), questionsSnap.val());
            }

            alert('Tema clonado exitosamente');
            setOriginalTemaId(''); setTargetCloneId('');
        } catch (e) { alert('Error: ' + e.message); }
    };

    const handleCopySpecialtyTema = async () => {
        if (!copySrcJerarquia || !copySrcCuerpo || !copySrcEspecialidad || !copySrcTemaId ||
            !copyDstJerarquia || !copyDstCuerpo || !copyDstEspecialidad || !copyDstTemaId) {
            return setCopyStatus('Completa todos los campos de origen y destino');
        }
        setCopyStatus('Leyendo tema origen...');
        try {
            const srcPath = `especialidades_temas/${copySrcJerarquia}/${copySrcCuerpo}/${copySrcEspecialidad}/temas/${copySrcTemaId}`;
            const srcSnap = await get(ref(database, srcPath));
            if (!srcSnap.exists()) return setCopyStatus('Tema origen no encontrado');

            const srcData = srcSnap.val();
            const dstPath = `especialidades_temas/${copyDstJerarquia}/${copyDstCuerpo}/${copyDstEspecialidad}/temas/${copyDstTemaId}`;
            await set(ref(database, dstPath), {
                id: parseInt(copyDstTemaId),
                nombre: srcData.nombre || '',
                descripcion: srcData.descripcion || '',
                jerarquia: copyDstJerarquia,
                cuerpo: copyDstCuerpo,
                especialidad: copyDstEspecialidad,
            });

            const quizzesSnap = await get(ref(database, `${srcPath}/cuestionarios`));
            if (quizzesSnap.exists()) {
                const quizzesData = quizzesSnap.val();
                const updates = {};
                Object.keys(quizzesData).forEach((qId) => {
                    updates[`${dstPath}/cuestionarios/${qId}`] = quizzesData[qId];
                });
                await update(ref(database), updates);
                setCopyStatus(`✓ Copiado: 1 tema + ${Object.keys(quizzesData).length} cuestionario(s)`);
            } else {
                setCopyStatus('✓ Tema copiado (sin cuestionarios)');
            }
        } catch (e) {
            setCopyStatus('Error: ' + e.message);
        }
    };

    const handleBulkAssign = async () => {
        if (selectedBulkThemeIds.length === 0) {
            alert('Selecciona al menos un tema');
            return;
        }

        try {
            console.log('[BulkAssign] Iniciando asignación masiva...');
            console.log(`[BulkAssign] Temas seleccionados: ${selectedBulkThemeIds.join(', ')}`);
            console.log(`[BulkAssign] Grados a asignar: ${bulkRanks.join(', ') || 'TODOS'}`);
            console.log(`[BulkAssign] Cuerpo: ${bulkCuerpo}, Especialidad: ${bulkEspecialidad}`);

            const temasUpdates = {};
            for (const themeId of selectedBulkThemeIds) {
                const existingTema = temas.find(t => t.id === themeId);
                let finalRanks = bulkRanks.length > 0 ? bulkRanks.join(',') : 'TODOS';

                // Si NO es modo estricto y ya tiene grados, hacemos un merge de los grados
                if (!isStrictMode && existingTema?.grados && existingTema.grados !== 'TODOS' && finalRanks !== 'TODOS') {
                    const currentSet = new Set(existingTema.grados.split(',').map(s => s.trim()));
                    bulkRanks.forEach(r => currentSet.add(r));
                    finalRanks = Array.from(currentSet).join(',');
                }

                temasUpdates[`${themeId}/grados`] = finalRanks;
                temasUpdates[`${themeId}/cuerpo_servicio`] = bulkCuerpo;
                temasUpdates[`${themeId}/especialidad`] = bulkEspecialidad;
            }

            // Modo estricto: remover los grados seleccionados de todos los demás temas no seleccionados
            if (isStrictMode && bulkRanks.length > 0 && bulkRanks[0] !== 'TODOS') {
                temas.forEach(t => {
                    if (!selectedBulkThemeIds.includes(t.id)) {
                        const tGrados = t.grados?.split(',').map(s => s.trim()) || [];
                        const filtered = tGrados.filter(g => !bulkRanks.includes(g));
                        const newGrados = filtered.length > 0 ? filtered.join(',') : 'TODOS';
                        if (newGrados !== t.grados) {
                            temasUpdates[`${t.id}/grados`] = newGrados;
                        }
                    }
                });
            }

            console.log('[BulkAssign] Payload a enviar a Firebase:', temasUpdates);
            
            // Hacemos el update especificando explícitamente el nodo 'temas'
            await update(ref(database, 'temas'), temasUpdates);
            
            console.log('[BulkAssign] ¡Asignación completada con éxito!');
            alert(`✅ Asignación masiva completada para ${selectedBulkThemeIds.length} temas`);
            setSelectedBulkThemeIds([]);
        } catch (e) { 
            console.error('[BulkAssign] Error crítico:', e);
            alert('Error al guardar en Firebase: ' + e.message); 
        }
    };

    const handleImportLastQuiz = async () => {
        try {
            console.log("[AdminPanel] 📥 Iniciando importación desde caché...");
            
            // Vamos directamente a la caché de administración que es donde VortexDocs guarda
            const cacheRef = ref(database, 'admin/last_generated_quiz');
            const cacheSnap = await get(cacheRef);
            
            if (cacheSnap.exists()) {
                const data = cacheSnap.val();
                console.log("[AdminPanel] ✅ Datos recuperados de la caché:", data);
                
                setQuizzId(data.id || '');
                setQuizzTitulo(data.titulo || '');
                
                // Asegurarnos de que las preguntas se conviertan a string JSON para el textarea
                const questionsJson = JSON.stringify(data.preguntas, null, 2);
                setQuizzJson(questionsJson);
                
                alert('Último cuestionario importado desde la caché de administración');
            } else {
                console.warn("[AdminPanel] ⚠️ La caché 'admin/last_generated_quiz' está vacía.");
                alert('No se encontró un cuestionario reciente en la caché. Por favor, genéralo primero en Vortex Docs.');
            }
        } catch (e) { 
            console.error("[AdminPanel] ❌ Error crítico al importar:", e);
            alert('Error al importar: ' + e.message); 
        }
    };

    const handlePublishSpecialtyQuizz = async () => {
        if (!specialtyQuizzJerarquia || !specialtyQuizzCuerpo || !specialtyQuizzEspecialidad || !specialtyQuizzTemaId || !quizzId || !quizzTitulo || !quizzJson) {
            alert('Campos obligatorios faltantes');
            return;
        }

        try {
            let parsedJson;
            try { parsedJson = JSON.parse(quizzJson); } catch (e) { return alert('JSON inválido'); }

            const quizzIdNumber = parseInt(quizzId.replace(/[^0-9]/g, '')) || Date.now() % 10000;

            // Normalización robusta: Forzamos IDs secuenciales para evitar duplicados
            const formattedQuestions = parsedJson.map((q, qIdx) => {
                const qId = qIdx + 1; // ID único basado en el orden real
                const rawRespuestas = q.respuestas || q.options || [];
                return {
                    id: qId,
                    pregunta: q.pregunta || q.question || 'Sin pregunta',
                    respuestas: rawRespuestas.map((opt, optIdx) => {
                        const rId = (qId * 10) + optIdx; // ID de respuesta vinculado al ID de pregunta
                        const isString = typeof opt === 'string';
                        
                        let isCorrect = false;
                        if (isString) {
                            isCorrect = (Number(optIdx) === Number(q.correctAnswer)) || (opt === q.respuesta) || (opt === q.respuesta_correcta);
                        } else {
                            isCorrect = opt.correcta === true || opt.correcta === 1 || String(opt.correcta) === "1" || String(opt.correcta).toLowerCase() === "true";
                        }
                        
                        return {
                            id: rId,
                            respuesta: isString ? opt : (opt.respuesta || opt.texto || 'Sin respuesta'),
                            correcta: isCorrect
                        };
                    }),
                    explicacion: q.explicacion || q.explanation || ''
                };
            });

            const path = `especialidades_temas/${specialtyQuizzJerarquia}/${specialtyQuizzCuerpo}/${specialtyQuizzEspecialidad}/temas/${specialtyQuizzTemaId}/cuestionarios/${quizzIdNumber}`;

            await set(ref(database, path), {
                id: quizzIdNumber,
                titulo: quizzTitulo,
                preguntas: formattedQuestions,
                publicado: serverTimestamp()
            });

            await updateCacheVersion();
            alert('Cuestionario de especialidad publicado exitosamente en la ruta de paridad Android');
            setQuizzId(''); setQuizzTitulo(''); setQuizzJson('');
        } catch (e) { alert('Error: ' + e.message); }
    };

    const updateCacheVersion = async () => { /* no-op */ };

    const handlePublishGeneralQuizz = async () => {
        if (!generalQuizzTemaId || !quizzJson) {
            alert('Selecciona un tema y asegúrate de tener el JSON del cuestionario');
            return;
        }

        try {
            let parsedJson;
            try { parsedJson = JSON.parse(quizzJson); } catch (e) { return alert('JSON inválido'); }

            const themeId = parseInt(generalQuizzTemaId);

            // Normalización robusta: Forzamos IDs secuenciales (1, 2, 3...) para evitar que 
            // preguntas de diferentes lotes (chunks) se sobrescriban entre sí.
            const questionsUpdate = {};
            parsedJson.forEach((q, qIdx) => {
                const qId = qIdx + 1; // Usamos siempre el índice para garantizar unicidad
                const rawRespuestas = q.respuestas || q.options || [];
                
                const formattedRespuestas = {};
                rawRespuestas.forEach((opt, optIdx) => {
                    const rId = (qId * 10) + optIdx;
                    const isString = typeof opt === 'string';
                    
                    let isCorrect = false;
                    if (isString) {
                        isCorrect = (Number(optIdx) === Number(q.correctAnswer)) || (opt === q.respuesta) || (opt === q.respuesta_correcta);
                    } else {
                        isCorrect = opt.correcta === true || opt.correcta === 1 || String(opt.correcta) === "1" || String(opt.correcta).toLowerCase() === "true";
                    }
                    
                    formattedRespuestas[rId] = {
                        id: rId,
                        respuesta: isString ? opt : (opt.respuesta || opt.texto || 'Sin respuesta'),
                        correcta: isCorrect
                    };
                });

                questionsUpdate[qId] = {
                    id: qId,
                    temaId: themeId,
                    tema_id: themeId,
                    pregunta: q.pregunta || q.question || 'Sin pregunta',
                    respuestas: formattedRespuestas,
                    explicacion: q.explicacion || q.explanation || ''
                };
            });

            const path = `preguntas_por_tema/${themeId}`;
            await set(ref(database, path), questionsUpdate);

            await updateCacheVersion();
            alert(`¡Cuestionario general publicado exitosamente para el tema ${themeId}!`);
            setQuizzJson('');
        } catch (e) { alert('Error: ' + e.message); }
    };

    const handleTriggerRemoteSync = async () => {
        if (!window.confirm("¿Activar sincronización remota para TODOS los usuarios? Esto forzará a las apps a descargar la base de datos de nuevo.")) return;
        try {
            // CRÍTICO: Usar set() (no update()) para sobreescribir el nodo completo.
            // Esto garantiza que 'status' siempre vuelva a 'pending' incluso si antes era 'completed'.
            // Usar Date.now() como número explícito para compatibilidad con Long en Kotlin.
            const nowTimestamp = Date.now();
            await set(ref(database, 'public_sync/database_update'), {
                action: 'force_database_sync',
                status: 'pending',
                timestamp: nowTimestamp,
                triggered_by: 'web_admin',
                triggered_at: new Date(nowTimestamp).toISOString()
            });
            await updateCacheVersion();
            alert(`✅ Comando de sincronización enviado a todas las Apps.\nTimestamp: ${nowTimestamp}`);
        } catch (e) { alert('Error: ' + e.message); }
    };


    const handleApproveProposal = async (proposal) => {
        try {
            const metadataRef = ref(database, 'app_metadata');
            const snap = await get(metadataRef);
            let metadata = snap.exists() ? snap.val() : { especialidades: {}, cuerpos: [], servicios: [] };

            let changed = false;
            if (proposal.requestedSpecialty) {
                if (!metadata.especialidades) metadata.especialidades = {};
                const currentList = metadata.especialidades[proposal.cuerpoServicio] || [];
                if (!currentList.includes(proposal.requestedSpecialty)) {
                    metadata.especialidades[proposal.cuerpoServicio] = [...currentList, proposal.requestedSpecialty];
                    changed = true;
                }
            }

            if (changed) await set(metadataRef, metadata);

            const path = `especialidades_temas/${proposal.jerarquia}/${proposal.cuerpoServicio}/${proposal.requestedSpecialty}`;
            await update(ref(database, path), { habilitado: true });
            await update(ref(database, `specialty_proposals/${proposal.id}`), { status: 'approved' });

            alert('Propuesta aprobada y metadatos actualizados');
        } catch (e) { alert('Error al aprobar: ' + e.message); }
    };

    const handleRejectProposal = async (id) => {
        try {
            await update(ref(database, `specialty_proposals/${id}`), { status: 'rejected' });
            alert('Propuesta rechazada');
        } catch (e) { alert('Error'); }
    };

    // --- RENDER HELPERS ---

    const renderHeader = (title, icon, section) => (
        <div className="section-header" onClick={() => toggleSection(section)} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '15px' }}>
            <span style={{ fontSize: '1.4rem', marginRight: '10px' }}>{icon}</span>
            <h3 style={{ margin: 0, flex: 1 }}>{title}</h3>
            <span>{expandedSections[section] ? '▲' : '▼'}</span>
        </div>
    );

    if (loading) return <div className="loading">Cargando Gestor de Paridad...</div>;

    const filteredBulkTemas = temas.filter(t => t.nombre.toLowerCase().includes(bulkSearchQuery.toLowerCase()));

    return (
        <div className="admin-quizz-mgmt" style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                <h1 style={{ color: 'var(--accent)', margin: 0 }}>🧠 Gestor de Quizzes (Vortex Docs Admin)</h1>
                <button onClick={() => window.history.back()} className="btn-secondary">← Volver</button>
            </div>

            <div className="admin-grid" style={{ display: 'grid', gap: '20px' }}>

                {/* NAVEGACIÓN VORTEX DOCS */}
                <div className="admin-card-clickable" style={{ padding: '20px', background: 'linear-gradient(135deg, #6200ea, #311b92)', borderRadius: '15px', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', marginBottom: '10px' }} onClick={() => navigate('/dashboard/admin/vortex-docs')}>
                    <div>
                        <h3 style={{ margin: 0 }}>✨ Generador Vortex Docs</h3>
                        <p style={{ margin: 0, opacity: 0.8, fontSize: '0.9rem' }}>Ir al generador de IA para crear nuevos bancos de preguntas.</p>
                    </div>
                    <span style={{ fontSize: '1.5rem' }}>➜</span>
                </div>

              
                {/* CREACIÓN DE TEMAS GENERALES */}
                <div className="admin-card-expandable">
                    {renderHeader("Crear Nuevo Tema General (RTDB)", "📖", "createBasicTema")}
                    {expandedSections.createBasicTema && (
                        <div className="section-body form-grid-2">
                            <div className="input-group">
                                <label>Área Perteneciente</label>
                                <select value={selectedAreaId} onChange={e => setSelectedAreaId(e.target.value)}>
                                    <option value="">Seleccionar área...</option>
                                    {areas.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}
                                </select>
                            </div>
                            <div className="input-group">
                                <label>ID del Tema</label>
                                <input type="number" placeholder="Ej: 101" value={newTemaId} onChange={e => setNewTemaId(e.target.value)} />
                            </div>
                            <div className="input-group" style={{ gridColumn: 'span 2' }}>
                                <label>Nombre del Tema</label>
                                <input type="text" placeholder="Ej: Navegación Costera" value={newTemaNombre} onChange={e => setNewTemaNombre(e.target.value)} />
                            </div>
                            <button className="btn-save full-width" onClick={handleCreateBasicTema}>➕ Crear Tema General</button>
                        </div>
                    )}
                </div>

            </div>

            <style>{`
                .admin-quizz-mgmt { color: white; }
                .admin-card-expandable { background: var(--bg-secondary); border-radius: 15px; overflow: hidden; border: 1px solid rgba(255,255,255,0.05); margin-bottom: 20px; transition: all 0.3s ease; }
                .admin-card-expandable:hover { border-color: var(--accent); transform: translateY(-2px); box-shadow: 0 5px 15px rgba(0,0,0,0.3); }
                .section-header { background: rgba(255,255,255,0.02); border-bottom: 1px solid rgba(255,255,255,0.05); }
                .section-body { padding: 20px; animation: slideDown 0.3s ease-out; }
                
                .form-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; }
                .form-row-compact { display: flex; gap: 15px; grid-column: span 2; }
                .input-group { display: flex; flex-direction: column; gap: 5px; }
                .input-group label { font-size: 0.8rem; font-weight: bold; color: var(--accent); }
                .input-group input, .input-group select, .input-group textarea { padding: 12px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(0,0,0,0.2); color: white; }
                
                .chip { padding: 5px 12px; background: rgba(255,255,255,0.05); border-radius: 20px; font-size: 0.75rem; cursor: pointer; border: 1px solid rgba(255,255,255,0.1); transition: 0.2s; }
                .chip.active { background: var(--accent); color: white; border-color: var(--accent); font-weight: bold; }
                
                .theme-selector-box { border: 1px solid rgba(255,255,255,0.1); border-radius: 10px; background: rgba(0,0,0,0.1); overflow: hidden; }
                .search-input { width: 100%; border: none; padding: 15px; background: rgba(255,255,255,0.03); color: white; border-bottom: 1px solid rgba(255,255,255,0.05); }
                .theme-list-scroll { max-height: 250px; overflow-y: auto; padding: 10px; }
                .theme-item-check { display: flex; align-items: center; gap: 10px; padding: 10px; border-radius: 8px; cursor: pointer; transition: 0.2s; }
                .theme-item-check:hover { background: rgba(255,255,255,0.05); }
                
                .proposal-item-card { display: flex; justify-content: space-between; align-items: center; background: rgba(0,0,0,0.2); padding: 15px; border-radius: 10px; margin-bottom: 10px; border-left: 4px solid var(--accent); }
                .prop-info { display: flex; flex-direction: column; gap: 2px; }
                .prop-info strong { color: var(--accent); }
                .prop-info span { font-size: 0.8rem; opacity: 0.6; }
                .prop-actions { display: flex; gap: 10px; }
                .btn-mini-approve { background: var(--success-color); color: white; border: none; border-radius: 4px; padding: 5px 12px; cursor: pointer; }
                .btn-mini-action { background: var(--accent); color: white; border: none; border-radius: 4px; padding: 5px 12px; cursor: pointer; }
                .btn-mini-reject { background: #f44336; color: white; border: none; border-radius: 4px; padding: 5px 10px; cursor: pointer; }

                .full-width { width: 100%; }
                
                @keyframes slideDown {
                    from { opacity: 0; transform: translateY(-10px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                @media (max-width: 768px) {
                    .form-grid-2 { grid-template-columns: 1fr; }
                    .form-row-compact { flex-direction: column; grid-column: span 1; }
                }
            `}</style>
        </div>
    );
};

export default AdminQuizzManagement;
